import { Map, List, fromJS } from 'immutable'
import {
  SET_PM_SECTION,
  SET_PM_SECTION_ERROR,
  SET_PM_SECTION_DONE,
  SET_PM_SECTION_PROCESSING,
  DELETE_PM_SECTION,
  DELETE_MULTIPLE_PM_SECTIONS,
} from './actions'

export const initialState = Map()

/**
 * Page manager section reducer
 */
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SET_PM_SECTION: {
      const {
        sectionId, data, done = false, processing = false,
      } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([sectionId, 'processing'], processing)
          .setIn([sectionId, 'dataCreated'], new Date())
          .setIn([sectionId, 'done'], done)
          .setIn([sectionId, 'data'], fromJS(data))
          .deleteIn([sectionId, 'error'])
          .deleteIn([sectionId, 'errorCreated'])
        // Track processing
        if (processing) {
          mutableState
            .setIn([sectionId, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([sectionId, 'processingEnded'], new Date())
        }
      })
    }
    case SET_PM_SECTION_DONE: {
      const { sectionId, done } = action.payload
      return state.setIn([sectionId, 'done'], done)
    }
    case SET_PM_SECTION_PROCESSING: {
      const { sectionId, processing = true } = action.payload
      // Track processing
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([sectionId, 'processing'], processing)
        // Track processing
        if (processing) {
          mutableState
            .setIn([sectionId, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([sectionId, 'processingEnded'], new Date())
        }
      })
    }
    case SET_PM_SECTION_ERROR: {
      const {
        sectionId, error, processing = false, done = true,
      } = action.payload
      return state.withMutations((mutableState) => {
        mutableState
          .setIn([sectionId, 'processing'], processing)
          .setIn([sectionId, 'done'], done)
          .deleteIn([sectionId, 'dataCreated'])
          .deleteIn([sectionId, 'data'])
          .setIn([sectionId, 'error'], error)
          .setIn([sectionId, 'errorCreated'], new Date())
        // Track processing
        if (processing) {
          mutableState
            .setIn([sectionId, 'processingStarted'], new Date())
        } else {
          mutableState
            .setIn([sectionId, 'processingEnded'], new Date())
        }
      })
    }
    case DELETE_PM_SECTION: {
      const { sectionId } = action.payload
      return state.delete(sectionId)
    }
    case DELETE_MULTIPLE_PM_SECTIONS: {
      const { sectionIds = List() } = action.payload
      return state.withMutations((mutableState) => {
        sectionIds.forEach((sectionId) => mutableState.delete(sectionId))
      })
    }
    default:
      return state
  }
}
